export const UPDATE_ENTITIES = 'UPDATE_ENTITIES';
